module.exports = __webpack_public_path__ + "img/ErrorOperativo.302ce2ff.svg";